import { useQuery } from '@tanstack/react-query';

import apiClient from '../../../../api/axios';
import type { TModifier } from '../modifiers/types';

type TModifiersResponse = {
  success: boolean;
  data: {
    rows: TModifier[];
    total: number;
    pages: number;
    pageNum: number;
    pageSize: number;
  };
};

export const MODIFIERS_QUERY_KEY = 'menu-modifiers';

export const useGetModifiers = (restaurantId: string) => {
  return useQuery({
    queryKey: [MODIFIERS_QUERY_KEY, restaurantId],
    queryFn: async () => {
      const response = await apiClient.get<TModifiersResponse>(
        '/menu_modifier?pageSize=10000&pageNum=1',
        { headers: { 'Restaurant-ID': restaurantId } }
      );
      return response.data?.data?.rows ?? [];
    },
    enabled: !!restaurantId,
  });
};
